import React, { useState, useEffect } from "react";
import { Input, Row, Col, Divider, Button, Form, message } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import ProfileService from "../../../../../services/Profile/ProfileService";
import { updateMemberInfo } from "../../../../../store/actions";



const Edit = ({ memberData, onSuccess, onClose }) => {
    const token = useSelector((state) => state.Member.token);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const dispatchRedux = useDispatch();


    useEffect(() => {
        form.setFieldsValue({
            phone: memberData.phone,
            email: memberData.email,
        });
    }, [form, memberData]);


    const formatRequestData = (data) => {
        const requestData = {
            phone: data.phone ? data.phone : "",
            email: data.email ? data.email : ""
        }
        return requestData;
    }


    const onSave = () => {
        setLoading(true);
        form
            .validateFields()
            .then((data) => {
                const requestData = formatRequestData(data);
                ProfileService.updateProfileDetails(token, requestData)
                    .then((response) => {
                        const myInfo = {
                            phone: response.data.phone,
                            email: response.data.email
                        }
                        dispatchRedux(updateMemberInfo(myInfo));
                        message.success("Modifikimi u krye me sukses!", 1).then(() => {
                            setLoading(false);
                            onSuccess();
                        });
                    })
                    .catch((err) => {
                        const errorMessage = err.response.data.Error
                            ? err.response.data.Error
                            : "Një gabim ndodhi gjatë modifikimit!";
                        message.error(errorMessage, 3).then(() => {
                            setLoading(false);
                        });
                    });
            }).catch(() => { setLoading(false); });
    };


    return (
        <>
            <Form
                form={form}
                layout="vertical"
            >
                <Row gutter={24} style={{ width: "100%" }} className='mt-5'>
                    <Divider style={{ marginTop: "0px", marginBottom: "10px" }} />
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Row gutter={24} align="middle">
                        <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Emri plotë:</Col>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                        <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData?.name + " " + memberData?.surname}</Col>
                        </Row>
                    </Col>
                    <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                    <Col span={24}>
                        <Row gutter={24} align="middle">
                            <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Username:</Col>
                            <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                            <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData?.user?.username}</Col>
                        </Row>
                    </Col>
                    <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                    <Col span={24}>
                        <Row gutter={24} align="middle">
                            <Col xl={8} lg={8} md={8} sm={8} xs={8} className="font-weight-bold">Vendodhja:</Col>
                            <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
                            <Col xl={14} lg={14} md={14} sm={14} xs={14}>{memberData.living_place}</Col>
                        </Row>
                    </Col>
                    <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                    <Col span={24}>
                        <Row gutter={24} align="middle">
                            <Col xl={8} lg={8} md={24} sm={24} xs={24} className="font-weight-bold">Mobile:</Col>
                            <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                                <Form.Item name="phone" className="m-0 p-0">
                                    <Input
                                        type="text"
                                        placeholder="Mobile..."
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                    <Col span={24}>
                        <Row gutter={24} align="middle">
                            <Col xl={8} lg={8} md={24} sm={24} xs={24} className="font-weight-bold">Email:</Col>
                            <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                                <Form.Item name="email" className="m-0 p-0">
                                    <Input
                                        type="email"
                                        placeholder="Email..."
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                </Row>
                <Row gutter={24} className="mt-3">
                    <Col xl={24} lg={24} md={24} sm={24} xs={24} className='text-center'>
                        <Button
                            type="primary"
                            className="mr-4"
                            onClick={() => onSave()}
                            loading={loading}
                            icon={<CheckOutlined />}
                        >
                            Ruaj
                        </Button>
                        <Button
                            danger
                            onClick={onClose}
                            icon={<CloseOutlined />}
                        >
                            Mbyll
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    );
};

export default Edit;